export default __webpack_public_path__ + "static/media/logo_icon.fab4b2d9.png";